import api from './api';
import { LoginRequest, LoginResponse, User } from '../types/types';

export const authService = {
  login: async (credentials: LoginRequest): Promise<LoginResponse> => {
    const response = await api.post('/auth/login', credentials);
    return response.data;
  },

  logout: () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userInfo');
    try { window.dispatchEvent(new Event('apporari-user-changed')); } catch {}
    window.location.href = '/login';
  },

  getCurrentUser: (): User | null => {
    const userInfo = localStorage.getItem('userInfo');
    return userInfo ? JSON.parse(userInfo) : null;
  },

  getToken: (): string | null => {
    return localStorage.getItem('authToken');
  },

  isAuthenticated: (): boolean => {
    const token = localStorage.getItem('authToken');
    return !!token;
  },

  storeAuthData: (response: LoginResponse) => {
    localStorage.setItem('authToken', response.token);
    localStorage.setItem('userInfo', JSON.stringify({
      nome: response.nome,
      username: response.username, // Salviamo anche il campo username
      ruolo: response.ruolo,
      negozio: response.negozio,
      abilitaInsOrari: response.abilitaInsOrari === true,
      oldId: response.oldId || null
    }));
    try { window.dispatchEvent(new Event('apporari-user-changed')); } catch {}
  },

  changePassword: async (username: string, newPasswd: string): Promise<void> => {
    await api.post('/auth/change-password', { username, newPassword: newPasswd });
  }
};
